<template>
  <v-app>
    <!-- <app-global-error v-if="globalError"></app-global-error> -->
    <app-alert-dialog :model="hasGlobalError" :didDismiss="didDismiss" ></app-alert-dialog>
    <div>
      <app-layout-unauthenticated v-if="!isAuthenticated"></app-layout-unauthenticated>
      <app-layout-authenticated v-else-if="isFV"></app-layout-authenticated>
      <app-layout-authenticated-developer v-else></app-layout-authenticated-developer>
    </div>
  </v-app>
</template>

<script>
export default {
  computed: {
    hasGlobalError () {
      return this.$store.getters.hasGlobalError
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    isFV () {
      return localStorage.getItem('fv') === 1
    }
  },
  created () {
    console.log('App.vue : Created')
    const that = this
    // If we are running app in browser during development
    // then we manualy simulate calling the startApp
    const inBrowser = window.localStorage.getItem('inBrowser')
    if (inBrowser) {
      const payload = {
        appVersion: '0.1.0',
        platform: 'mobile',
        appToken: window.localStorage.getItem('token')
      }
      that.$store.dispatch('app/startApp', payload)
    } else {
      window.actions = window.actions || {}
      window.actions.startApp = function (json) {
        const data = JSON.parse(json)
        console.log(data)
        const payload = {
          appVersion: data.appVersion,
          platform: data.platform,
          appToken: data.appToken
        }
        that.$store.dispatch('app/startApp', payload)
      }
    }
  },
  methods: {
    didDismiss () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>

<style>

</style>
